export function toCamelCase(str: string): string {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

export function formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes <= 0) return '0 Bytes';
  
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
  
    const value = bytes / Math.pow(1024, i);
    return `${value.toFixed(decimals)} ${sizes[i]}`;
  }
  